import { useState, useEffect } from 'react';

interface ResponsiveFlags {
  isMobile: boolean;   // < 768px
  isTablet: boolean;   // 768px - 1024px
  isDesktop: boolean;  // > 1024px
  windowWidth: number;
}

export function useResponsive(): ResponsiveFlags {
  const [windowWidth, setWindowWidth] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth : 1200
  );

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    isMobile: windowWidth < 768,
    isTablet: windowWidth >= 768 && windowWidth <= 1024,
    isDesktop: windowWidth > 1024,
    windowWidth,
  };
}
